import { inject, Pipe, PipeTransform } from '@angular/core';
import { UserStateService } from '../services/user-state.service';

@Pipe({
  name: 'hasRole',
  standalone: true,
  pure: true,
})
export class HasRolePipe implements PipeTransform {
  private userStateService = inject(UserStateService);

  transform(allowedRoles: string | string[]): boolean {
    const role = this.userStateService.userRole();

    if (!role) return false;

    const rolesArray = Array.isArray(allowedRoles) ? allowedRoles : [allowedRoles];

    return rolesArray.includes(role);
  }
}
